import request from '@/utils/request'

export function fetchKolList(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/kol/list',
    method: 'post',
    data: data
  })
}

export function getDrawResult(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/draw/draw',
    method: 'post',
    params: data
  })
}

export function fetchKolVote(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/kol/vote',
    method: 'post',
    data: data
  })
}


export function fetchKolSearch(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/kol/search',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/views/activity_209/api.js